<div class="container text-center p-4 ">
    <div class="row main-cont" >

        <div class="col-12">
            <div>
                <h5><i class="la la-check-circle"
                       style="font-size: 30px;color: green"></i>   &nbsp; <b> {{'has_been_successfully' | translate}}</b></h5>

            </div>
            <div>{{data.product.name}}</div>
        </div>

        <div class="col-12">

            <div class=" center text-center p-4 ">
                <button class="btn btn-primary" (click)="continueToBuy()" style="background-color: #509900">{{'continue_to_buy' | translate}}</button>
                &nbsp;
                <button class="btn btn-primary" (click)="close()">{{'back_to_shopping' | translate}}</button>
            </div>
        </div>

    </div>


</div>




